import { GetLocal, PostLocal } from "../utilities/AxiosUtility";
import { localPort, version } from "../utilities/Constants";
import Cookie, { removeSession } from "../utilities/CookieUtility";

export default class ProductApi {
  static async getList() {
    const response = await GetLocal(`${localPort}/${version}/ddish/getProduct`);
    //console.log({ response });
    if (response && response.data.issuccess === true) {
      return response.data;
    } else {
      if (response.data.resultMessage == "token has been expired") {
        Cookie.remove("auth");
        window.location.reload();
      }
      return "failed";
    }
  }

  static async chargeProduct(card_no, pid, month, price) {
    let query = {};
    console.log(pid);
    console.log("               ");
    query = {
      card_no: card_no,
      pid: pid,
      month: month,
      price: price,
    };
    console.log(query);
    const response = await PostLocal(
      `${localPort}/${version}/ddish/chargeProduct`,
      query
    );
    return response.data;
  }
}
